export const SANITIZE_PROFILE_RESTRICTED = {
    allowedAttributes: {},
    allowedSchemes: [],
    allowedTags: ['p', 'div', 'br'],
};
